<svg xmlns="http://www.w3.org/2000/svg"
     class="board"
     [attr.viewBox]="viewBoxString()"
     preserveAspectRatio="xMidYMid meet">
    <g id="quebec"
       [attr.transform]="getBoardTransform()">
        @for (coordAndContent of constructedState.getCoordsAndContents(); track coordAndContent.coord.toString()) {
            <g id="click-{{ coordAndContent.coord.x }}-{{ coordAndContent.coord.y }}"
               [attr.transform]="getTranslationAt(coordAndContent.coord)"
               (click)="onClick(coordAndContent.coord)">
                <rect id="square-{{ coordAndContent.coord.x }}-{{ coordAndContent.coord.y }}"
                      x="0"
                      y="0"
                      [attr.width]="SPACE_SIZE"
                      [attr.height]="SPACE_SIZE"
                      [ngClass]="getSquareClasses(coordAndContent.coord)"
                      class="base"/>
                @for (player of Player.PLAYERS; track player.getValue()) {
                    <ng-container>
                        @if (isPlayerCastle(player, coordAndContent.coord)) {
                            <g id="castle-{{ player.toString() }}-{{ state().castles.get(player).get().x }}-{{ state().castles.get(player).get().y }}"
                               style="pointer-events: none">
                                <polyline points="0 0, 100 100, 50 50, 100 0, 0, 100, 50 50, 0 50, 100 50, 50 50, 50 0, 50 100, 50 50"
                                          class="base-no-fill"/>
                            </g>
                        }
                    </ng-container>
                }
                @if (coordAndContent.content !== PlayerOrNone.NONE) {
                    <circle id="piece-{{ coordAndContent.coord.x }}-{{ coordAndContent.coord.y }}"
                            [attr.r]="(SPACE_SIZE / 2) - STROKE_WIDTH"
                            [attr.cx]="SPACE_SIZE / 2"
                            [attr.cy]="SPACE_SIZE / 2"
                            [ngClass]="getPieceClasses(coordAndContent.coord)"
                            class="base"/>
                }
                @if (possibleLanding.contains(coordAndContent.coord)) {
                    <rect id="landing-{{ coordAndContent.coord.x }}-{{ coordAndContent.coord.y }}"
                          [attr.x]="SPACE_SIZE * 0.4"
                          [attr.y]="SPACE_SIZE * 0.4"
                          [attr.width]="SPACE_SIZE * 0.2"
                          [attr.height]="SPACE_SIZE * 0.2"
                          class="indicator"/>
                }
            </g>
        }
    </g>
    @if (isPlayerDropping()) {
        <g>
            @if (getNumberOfAwaitedDrop() === 0) {
                <g id="drop-validator"
                   (click)="validateGroupDrop()"
                   [attr.transform]="getGroupValidatorTransform()">
                    <circle [attr.cx]="STROKE_WIDTH / 2"
                            [attr.cy]="STROKE_WIDTH / 2"
                            [attr.r]="SPACE_SIZE / 2"
                            fill="red"
                            class="base-no-fill mid-stroke"
                            [ngClass]="getGroupDropValidationButtonClasses()"/>
                    <polygon points="-32.5,-2.5 -32.5,12.5 -10,35 -2.5,35 35,-21.25 25,-21.275 -5,25 -32.5,-2.5"
                             fill="green"
                             class="base-no-fill mid-stroke"/>
                </g>
            } @else {
                @for (i of ArrayUtils.range(getNumberOfAwaitedDrop()); track i) {
                    <circle id="remaining-piece-{{ i }}"
                            [attr.cx]="getRemainingCx(i)"
                            [attr.cy]="getRemainingCy()"
                            class="base"
                            [ngClass]="getRemaininPieceClasses()"
                            [attr.r]="SPACE_SIZE / 2"/>
                }
            }
        </g>
    }
</svg>
